import React from "react";
import { motion } from "framer-motion";
import { FaLinkedin } from "react-icons/fa";
import maggieImg from "../../../assets/img/team-maggie.jpg";
import joanImg from "../../../assets/img/team-joan.png";

const TEAM = [
  {
    name: "Maggie Namaganda",
    role: "Co-Founder & CEO",
    image: maggieImg,
    linkedin: "https://www.linkedin.com/in/maggie-namaganda/",
  },
  {
    name: "Joan Bayega",
    role: "Co-Founder & CTO",
    image: joanImg,
    linkedin: "https://www.linkedin.com/in/joanbayega/",
  },
  {
    name: "Khalifan Muwonge",
    role: "Senior Software Engineer",
    gradient: "from-[#2A71E8] to-[#181059]",
    linkedin: "https://www.linkedin.com/in/muwonge-khalifan-499872225/",
  },
  {
    name: "Sudi Murindanyi",
    role: "Senior ML & AI Engineer",
    gradient: "from-[#BE2117] to-[#181059]",
    linkedin: "https://www.linkedin.com/in/sudi-murindanyi-aa8793150/",
  },
];

export default function TeamSection() {
  return (
    <section id="team" className="bg-white dark:bg-black py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-[#053676] dark:text-[#2A71E8] font-sans font-bold text-3xl sm:text-4xl mb-4">
            Meet Our Team
          </h2>
          <p className="text-[#09062C] dark:text-gray-300 font-sans font-medium text-lg max-w-2xl mx-auto">
            The passionate people behind Chusa working to make communication
            accessible for everyone
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {TEAM.map((member, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-white dark:bg-[#181818] rounded-[20px] aboutUsShadow p-6 text-center hover:shadow-xl transition-shadow duration-300 flex flex-col items-center justify-between"
            >
              <div className="w-36 h-36 rounded-full mx-auto mb-5 overflow-hidden flex-shrink-0">
                {member.image ? (
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top"
                  />
                ) : (
                  <div className={`w-full h-full bg-gradient-to-b ${member.gradient} flex items-center justify-center`}>
                    <span className="text-white font-sans font-bold text-4xl">
                      {member.name.charAt(0)}
                    </span>
                  </div>
                )}
              </div>

              <div className="flex-1 flex flex-col items-center justify-center">
                <h3 className="text-[#09062C] dark:text-white font-sans font-bold text-lg">
                  {member.name}
                </h3>
                <p className="text-[#2A71E8] font-sans font-medium text-sm mt-1">
                  {member.role}
                </p>
              </div>

              <div className="mt-4">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${member.name} on LinkedIn`}
                  className="w-9 h-9 bg-[#f4f4f4] dark:bg-black rounded-full flex items-center justify-center hover:bg-[#2A71E8] hover:text-white text-[#09062C] dark:text-gray-400 dark:hover:text-white transition-colors"
                >
                  <FaLinkedin size={16} />
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
